import { StepKey } from '/@/modules/guidancestep/enums/StepKey';

export const GuidanceStepCypressAttribute = {
  items: Object.values(StepKey).reduce((acc, key) => {
    acc[`STEP_GUIDANCE_ITEM_${key}`] = `GuidanceStepCypressAttribute:STEP_GUIDANCE_ITEM-${key}`;
    return acc;
  }, {}),
  itemsFn: (key) => `GuidanceStepCypressAttribute:STEP_GUIDANCE_ITEM-${key}`,
  inputs: {
    ESTATE_WILL_GUIDE_INSTRUCTIONS:
      'GuidanceStepCypressAttribute:inputs:ESTATE_WILL_GUIDE_INSTRUCTIONS',
    USER_DETAIL_FORM: 'GuidanceStepCypressAttribute:views:USER_DETAIL_FORM',
    FIRST_NATIONS_REGISTERED_STATUS:
      'GuidanceStepCypressAttribute:inputs:FIRST_NATIONS_REGISTERED_STATUS',
    FIRST_NATIONS_RESIDES_ON_RESERVE:
      'GuidanceStepCypressAttribute:inputs:FIRST_NATIONS_RESIDES_ON_RESERVE'
  },
  buttons: {},
  views: {
    categoryTabFn: (category) => `GuidanceStepCypressAttribute:views:CATEGORY_TAB_${category.key}`,
    categoryTabContentFn: (category) =>
      `GuidanceStepCypressAttribute:views:CATEGORY_TAB_CONTENT_${category.key}`,
    STEP_GUIDANCE_ITEM: `GuidanceStepCypressAttribute:STEP_GUIDANCE_ITEM-`,
    STEP_GUIDANCE_COLLAPSE_ITEM: `GuidanceStepCypressAttribute:STEP_GUIDANCE_COLLAPSE_ITEM-`,
    STEP_HEADER: 'GuidanceStepCypressAttribute:STEP_HEADER',
    STEP_HEADER_NAME: 'GuidanceStepCypressAttribute:STEP_HEADER_NAME',
    STEP_HEADER_UNDERLINED_DEFINITION:
      'GuidanceStepCypressAttribute:STEP_HEADER_UNDERLINED_DEFINITION',
    STEP_DESCRIPTION: 'GuidanceStepCypressAttribute:STEP_DESCRIPTION',
    FATHER_CONTACT_FORM: 'GuidanceStepCypressAttribute:FATHER_CONTACT_FORM',
    MOTHER_CONTACT_FORM: 'GuidanceStepCypressAttribute:MOTHER_CONTACT_FORM',
    HUBSPOT_MEETING_SCHEDULER: 'GuidanceStepCypressAttribute:HUBSPOT_MEETING_SCHEDULER',
    CALENDLY_MEETING_SCHEDULER: 'GuidanceStepCypressAttribute:CALENDLY_MEETING_SCHEDULER',
    HUBSPOT_MEETING_BOOKED: 'GuidanceStepCypressAttribute:HUBSPOT_MEETING_BOOKED',
    CALENDLY_MEETING_BOOKED: 'GuidanceStepCypressAttribute:CALENDLY_MEETING_BOOKED',
    FIRST_NATIONS_LEGAL_ADVISORY:
      'GuidanceStepCypressAttribute:views:FIRST_NATIONS_LEGAL_ADVISORY',
    FIRST_NATIONS_INDIAN_ACT_IMPACT:
      'GuidanceStepCypressAttribute:views:FIRST_NATIONS_INDIAN_ACT_IMPACT',
    FIRST_NATIONS_INDIAN_ACT_ACCORDION:
      'GuidanceStepCypressAttribute:views:FIRST_NATIONS_INDIAN_ACT_ACCORDION',
    FIRST_NATIONS_STATUS_QUESTIONS:
      'GuidanceStepCypressAttribute:views:FIRST_NATIONS_STATUS_QUESTIONS',
    FIRST_NATIONS_EDUCATION_BLOCK:
      'GuidanceStepCypressAttribute:views:FIRST_NATIONS_EDUCATION_BLOCK',
    PLANNING_STAGE_SUMMARY: 'GuidanceStepCypressAttribute:PLANNING_STAGE_SUMMARY',
    WARNING_BANNER_PLANNER_HAS_SENT_FOR_APPROVAL:
      'GuidanceStepCypressAttribute:WARNING_BANNER_PLANNER_HAS_SENT_FOR_APPROVAL',
    SUCCESS_BANNER_PLANNER_HAS_SENT_FOR_APPROVAL:
      'GuidanceStepCypressAttribute:SUCCESS_BANNER_PLANNER_HAS_SENT_FOR_APPROVAL',
    CHANGES_REQUESTED_BANNER: 'GuidanceStepCypressAttribute:views:CHANGES_REQUESTED_BANNER',
    COMMON_LAW_PARTNER_FULL_NAME: 'GuidanceStepCypressAttribute:views:COMMON_LAW_PARTNER_FULL_NAME',
    PERSONAL_INFORMATION_FULL_NAME:
      'GuidanceStepCypressAttribute:views:PERSONAL_INFORMATION_FULL_NAME',
    SPOUSE_FULL_NAME: 'GuidanceStepCypressAttribute:views:SPOUSE_FULL_NAME',
    NOTES: 'GuidanceStepCypressAttribute:views:NOTES',
    FINAL_REVIEW_SECTION_MISSING_INFO:
      'GuidanceStepCypressAttribute:views:FINAL_REVIEW_SECTION_MISSING_INFO',
    FINAL_REVIEW_MISSING_SECTIONS_BANNER:
      'GuidanceStepCypressAttribute:views:FINAL_REVIEW_MISSING_SECTIONS_BANNER',
    FINAL_REVIEW_PRODUCE_HELP_ICON:
      'GuidanceStepCypressAttribute:views:FINAL_REVIEW_PRODUCE_HELP_ICON',
    finalReviewSectionWarningIconFn: (key) =>
      `GuidanceStepCypressAttribute:views:FINAL_REVIEW_SECTION_WARNING_ICON-${key ?? ''}`
  },
  manage: {
    views: {},
    inputs: {},
    buttons: {
      GO_FROM_LOCKED_MODULE: 'GuidanceStepCypressAttribute:buttons:GO_FROM_LOCKED_MODULE'
    }
  },
  modal: {
    views: {
      HELP_BOX: 'GuidanceStepCypressAttribute:modal:views:HELP_BOX',
      QUEBEC_WILL_SEARCH_NOTIFICATION_BANNER:
        'GuidanceStepCypressAttribute:modal:views:QUEBEC_WILL_SEARCH_NOTIFICATION_BANNER',
      FORMER_SPOUSE_COLLAPSE: 'GuidanceStepCypressAttribute:modal:views:FORMER_SPOUSE_COLLAPSE',
      WILL_INTESTATE_BANNER: 'GuidanceStepCypressAttribute:modal:views:WILL_INTESTATE_BANNER',
      CREDITOR_CLAIM_DUE_DATE: 'steps:modal:view:CREDITOR_CLAIM_DUE_DATE',
      INVENTORY_AND_APPRAISAL_DATE: 'steps:modal:view:INVENTORY_AND_APPRAISAL_DATE',
      PET_FORM_COLLAPSE: 'GuidanceStepCypressAttribute:modal:views:PET_FORM_COLLAPSE',
      IDENTIFY_PET_SECTION: 'GuidanceStepCypressAttribute:modal:views:IDENTIFY_PET_SECTION',
      PET_SUMMARY: 'GuidanceStepCypressAttribute:modal:views:PET_SUMMARY',
      WIDGET_DESCRIPTION: 'GuidanceStepCypressAttribute:modal:views:WIDGET_DESCRIPTION',
      FAQ_DROPDOWN: 'GuidanceStepCypressAttribute:modal:views:FAQ_DROPDOWN',
      FAQ_DROPDOWN_ITEM: 'GuidanceStepCypressAttribute:modal:views:FAQ_DROPDOWN_ITEM',
      FAQ_DROPDOWN_ICON: 'GuidanceStepCypressAttribute:modal:views:FAQ_DROPDOWN_ICON',
      DID_THEY_HAVE_CHILDREN: 'GuidanceStepCypressAttribute:modal:views:DID_THEY_HAVE_CHILDREN',
      IS_THE_ESTATE_ONGOING: 'GuidanceStepCypressAttribute:modal:views:IS_THE_ESTATE_ONGOING',
      WHAT_BEST_DESCRIBES: 'GuidanceStepCypressAttribute:modal:views:WHAT_BEST_DESCRIBES',
      IN_CUSTODY_OF: 'GuidanceStepCypressAttribute:modal:views:IN_CUSTODY_OF',
      IN_CUSTODY_AT_THE_TIME_OF_PASSING:
        'GuidanceStepCypressAttribute:modal:views:IN_CUSTODY_AT_THE_TIME_OF_PASSING',
      LEGAL_GUARDIAN: 'GuidanceStepCypressAttribute:modal:views:LEGAL_GUARDIAN',
      MOTHERS_SURNAME_AT_BIRTH: 'GuidanceStepCypressAttribute:modal:views:MOTHERS_SURNAME_AT_BIRTH',
      FULL_TIME_STUDENT: 'GuidanceStepCypressAttribute:modal:views:FULL_TIME_STUDENT',
      ADDRESS: 'GuidanceStepCypressAttribute:modal:views:ADDRESS',
      RECEIVING_OR_APPLIED_CPP: 'GuidanceStepCypressAttribute:modal:views:RECEIVING_OR_APPLIED_CPP',
      FORMER_SPOUSE_ADDRESS: 'GuidanceStepCypressAttribute:modal:views:FORMER_SPOUSE_ADDRESS',
      CHILDREN_FROM_THIS_UNION: 'GuidanceStepCypressAttribute:modal:views:CHILDREN_FROM_THIS_UNION',
      LAST_KNOWN_OCCUPATION: 'GuidanceStepCypressAttribute:modal:views:LAST_KNOWN_OCCUPATION',

      IS_RETIRED: 'GuidanceStepCypressAttribute:modal:views:IS_RETIRED',
      REASON_FOR_NOT_ACTING: 'GuidanceStepCypressAttribute:modal:views:REASON_FOR_NOT_ACTING',
      LAST_THREE_DIGITS_SSN: 'GuidanceStepCypressAttribute:modal:views:LAST_THREE_DIGITS_SSN',
      LAST_THREE_DIGITS_DRIVERS_LICENSE_NUMBER:
        'GuidanceStepCypressAttribute:modal:views:LAST_THREE_DIGITS_DRIVERS_LICENSE_NUMBER',
      SPOUSE_ADDRESS: 'GuidanceStepCypressAttribute:modal:views:SPOUSE_ADDRESS',
      PLANNED_VALUE: 'GuidanceStepCypressAttribute:modal:views:PLANNED_VALUE',
      GUIDANCE_STEP_WIDGET: 'GuidanceStepCypressAttribute:modal:views:GUIDANCE_STEP_WIDGET',
      PROTECTION_MANDATE_GUIDANCE_STEP_WIDGET:
        'GuidanceStepCypressAttribute:modal:views:PROTECTION_MANDATE_GUIDANCE_STEP_WIDGET',
      REVIEW_FINANCIALS_GUIDANCE_STEP_WIDGET:
        'GuidanceStepCypressAttribute:modal:views:REVIEW_FINANCIALS_GUIDANCE_STEP_WIDGET'
    },
    inputs: {
      GENERATE: 'GuidanceStepCypressAttribute:modal:inputs:GENERATE',
      SOCIAL_INSURANCE_NUMBER: 'steps/modal/inputs/SOCIAL_INSURANCE_NUMBER',
      HEALTH_INSURANCE_NUMBER: 'steps/modal/inputs/HEALTH_INSURANCE_NUMBER',
      ORGANIZATION_NAME: 'steps/modal/inputs/ORGANIZATION_NAME',
      REGISTRATION_NUMBER: 'steps/modal/inputs/REGISTRATION_NUMBER',
      CONTACT: 'steps/modal/inputs/CONTACT',
      SHORT_CONTACT: 'steps/modal/inputs/SHORT_CONTACT',
      ADDRESS: 'steps/modal/inputs/ADDRESS',
      OCCUPIED_SINCE: 'steps/modal/inputs/OCCUPIED_SINCE',
      CREDITORS_SERVED: 'GuidanceStepCypressAttribute:modal:inputs:CREDITORS_SERVED',
      DATE_CREDITORS_SERVED: 'GuidanceStepCypressAttribute:modal:inputs:DATE_CREDITORS_SERVED',
      COHABITATION_START_DATE: 'steps/modal/inputs/COHABITATION_START_DATE',
      COHABITATION_END_DATE: 'steps/modal/inputs/COHABITATION_END_DATE',
      COURT_NOTIFIED: 'GuidanceStepCypressAttribute:modal:inputs:COURT_NOTIFIED',
      MARITAL_STATUS: 'steps/modal/inputs/MARITAL_STATUS',
      OTHER_EXPLANATION: 'GuidanceStepCypressAttribute:modal:inputs:OTHER_EXPLANATION',
      MATRIMONIAL_REGIME: 'GuidanceStepCypressAttribute:modal:inputs:MATRIMONIAL_REGIME',
      WEDDING_DATE: 'steps/modal/inputs/WEDDING_DATE',
      YES_NO_RADIO: 'steps/modal/inputs/YES_NO_RADIO',
      DOMESTIC_CONTRACT_DOCUMENT_UPLOAD:
        'GuidanceStepCypressAttribute:model:inputs:DOMESTIC_CONTRACT_DOCUMENT_UPLOAD',
      HAS_DOMESTIC_CONTRACT_YES_NO_RADIO:
        'GuidanceStepCypressAttribute:model:inputs:HAS_DOMESTIC_CONTRACT_YES_NO_RADIO',
      HAS_PETS_YES_NO_RADIO: 'GuidanceStepCypressAttribute:model:inputs:HAS_PETS_YES_NO_RADIO',
      HAS_PETS_ALTERNATE_TUTOR_YES_NO_RADIO:
        'GuidanceStepCypressAttribute:model:inputs:HAS_PETS_ALTERNATE_TUTOR_YES_NO_RADIO',
      HAS_LUMP_SUM_YES_NO_RADIO:
        'GuidanceStepCypressAttribute:model:inputs:HAS_LUMP_SUM_YES_NO_RADIO',
      HAS_LEGAL_GUARDIAN_YES_NO_RADIO:
        'GuidanceStepCypressAttribute:model:inputs:HAS_LEGAL_GUARDIAN_YES_NO_RADIO',
      HAS_CARE_GIVER_YES_NO_RADIO:
        'GuidanceStepCypressAttribute:model:inputs:HAS_CARE_GIVER_YES_NO_RADIO',
      HAS_BIOLOGICAL_CARE_GIVER_YES_NO_RADIO:
        'GuidanceStepCypressAttribute:model:inputs:HAS_BIOLOGICAL_CARE_GIVER_YES_NO_RADIO',
      HAS_MARRIAGE_CERTIFICATE_YES_NO_RADIO:
        'steps/modal/inputs/HAS_MARRIAGE_CERTIFICATE_YES_NO_RADIO',
      HAS_MARRIAGE_CONTRACT_YES_NO_RADIO: 'steps/modal/inputs/HAS_MARRIAGE_CONTRACT_YES_NO_RADIO',
      MARRIAGE_CONTRACT_HAS_TESTAMENTARY_CLAUSE_YES_NO_RADIO:
        'steps/modal/inputs/MARRIAGE_CONTRACT_HAS_TESTAMENTARY_CLAUSE_YES_NO_RADIO',
      MARRIAGE_CONTRACT_HAS_REVOCABLE_CLAUSE_YES_NO_RADIO:
        'GuidanceStepCypressAttribute:modal:inputs:MARRIAGE_CONTRACT_HAS_REVOCABLE_CLAUSE_YES_NO_RADIO',
      HAS_DONE_WILL_SEARCH_YES_NO_RADIO: 'steps/modal/inputs/HAS_DONE_WILL_SEARCH_YES_NO_RADIO',
      HAS_WILL_YES_NO_RADIO: 'steps/modal/inputs/HAS_WILL_YES_NO_RADIO',
      HAS_PENSION_YES_NO_RADIO: 'steps/modal/inputs/HAS_PENSION_YES_NO_RADIO',
      IS_VETERAN_YES_NO_RADIO: 'steps/modal/inputs/IS_VETERAN_YES_NO_RADIO',
      POSSESSION_YES_NO_RADIO: 'steps/modal/inputs/POSSESSION_YES_NO_RADIO',
      WITNESSES_BENEFICIARY_YES_NO_RADIO: 'steps/modal/inputs/WITNESSES_BENEFICIARY_YES_NO_RADIO',
      IS_NOTARIAL_YES_NO_RADIO: 'steps/modal/inputs/IS_NOTARIAL_YES_NO_RADIO',
      ID_UPLOAD: 'steps/modal/inputs/ID_UPLOAD',
      DOCUMENT_UPLOAD: 'steps/modal/inputs/DOCUMENT_UPLOAD',
      MARRIAGE_CONTRACT_UPLOAD: 'steps/modal/inputs/MARRIAGE_CONTRACT_UPLOAD',
      MARRIAGE_CONTRACT_NOTARY_FULL_NAME: 'steps/modal/inputs/MARRIAGE_CONTRACT_NOTARY_FULL_NAME',
      MARRIAGE_CONTRACT_DATE: 'steps/modal/inputs/MARRIAGE_CONTRACT_DATE',
      MARRIAGE_CONTRACT_MINUTES: 'steps/modal/inputs/MARRIAGE_CONTRACT_MINUTES',
      STREET_ADDRESS: 'steps/modal/inputs/STREET_ADDRESS',
      APARTMENT: 'steps/modal/inputs/APARTMENT',
      BIRTH_SURNAME: 'steps/modal/inputs/BIRTH_SURNAME',
      CITY: 'steps/modal/inputs/CITY',
      POSTAL_CODE: 'steps/modal/inputs/POSTAL_CODE',
      PHONE_NUMBER: 'steps/modal/inputs/PHONE_NUMBER',
      EMAIL: 'steps/modal/inputs/EMAIL',
      COUNTY: 'steps/modal/multiSelect/COUNTY',
      COUNTRY: 'steps/modal/multiSelect/COUNTRY',
      JURISDICTION: 'steps/modal/multiSelect/JURISDICTION',
      TEXT_JURISDICTION: 'steps/modal/multiSelect/TEXT_JURISDICTION',
      AREA: 'GuidanceStepCypressAttribute:modal:inputs:AREA',
      WILL: 'steps/modal/inputs/WILL',
      CODICIL_TO_THE_WILL_YES_NO_RADIO: 'steps/modal/inputs/CODICIL_TO_THE_WILL_YES_NO_RADIO',
      CODICIL_TO_WILL: 'steps/modal/inputs/CODICIL_TO_WILL',
      SELECT_ID: 'steps/modal/inputs/SELECT_ID',
      MARRIAGE_CERTIFICATE_TYPES_RADIO: 'steps/modal/inputs/MARRIAGE_CERTIFICATE_TYPES_RADIO',
      MARRIAGE_CERTIFICATE_UPLOAD: 'steps/modal/inputs/MARRIAGE_CERTIFICATE_UPLOAD',
      DEATH_CERTIFICATE_UPLOAD: 'steps/modal/inputs/DEATH_CERTIFICATE_UPLOAD',
      DIRVORCE_CERTIFICATE_UPLOAD: 'steps/modal/inputs/DIRVORCE_CERTIFICATE_UPLOAD',
      SELECT_FORM_DATE: 'steps/modal/inputs/SELECT_FORM_DATE',
      SELECT_TO_DATE: 'steps/modal/inputs/SELECT_TO_DATE',
      SELECT_STATEMENTS: 'steps/modal/inputs/SELECT_STATEMENTS',
      EVIDENCE: 'steps/modal/inputs/EVIDENCE',
      GENDER_OPTIONS: 'steps/modal/inputs/GENDER_OPTIONS',
      SELECT_DATE_OF_BIRTH: 'steps/modal/inputs/SELECT_DATE_OF_BIRTH',
      SELECT_DATE_OF_DEATH: 'steps/modal/inputs/SELECT_DATE_OF_DEATH',
      IS_OTHER_PARENT: 'steps/modal/inputs/IS_OTHER_PARENT',
      IS_IN_CUSTODY_SINCE_BIRTH: 'steps/modal/inputs/IS_IN_CUSTODY_SINCE_BIRTH',
      IS_STILL_IN_CUSTODY: 'steps/modal/inputs/IS_STILL_IN_CUSTODY',
      CANADIAN_PENSION_PLAN: 'steps/modal/inputs/CANADIAN_PENSION_PLAN',
      QUEBEC_PENSION_PLAN: 'steps/modal/inputs/QUEBEC_PENSION_PLAN',
      IS_SUPPORTING_ALL_CHILDREN: 'steps/modal/inputs/IS_SUPPORTING_ALL_CHILDREN',
      DOCUMENT_TYPES: 'steps/modal/inputs/DOCUMENT_TYPES',
      DOCUMENT_OTHERS: 'steps/modal/inputs/DOCUMENT_OTHERS',
      RESIDENCE_TYPE: 'steps/modal/inputs/RESIDENCE_TYPE',
      NUMBER_INPUT: 'steps/modal/inputs/NUMBER_INPUT',
      RENTED_REAL_ESTATE_TYPES: 'steps/modal/inputs/RENTED_REAL_ESTATE_TYPES',
      VEHICLE_TYPES: 'steps/modal/inputs/VEHICLE_TYPES',
      EMPLOYMENT_HISTORY_FAMILIARITY_TYPE: 'steps/modal/inputs/EMPLOYMENT_HISTORY_FAMILIARITY_TYPE',
      CHECKLIST_ITEM: 'steps/modal/inputs/CHECKLIST_ITEM',
      IS_VEHICLE_OWNED: 'steps/modal/inputs/IS_VEHICLE_OWNED',
      IS_VEHICLE_IN_USE: 'steps/modal/inputs/IS_VEHICLE_IN_USE',
      HAS_FIREARMS: 'steps/modal/inputs/HAS_FIREARMS',
      HAS_VALUABLES: 'steps/modal/inputs/HAS_VALUABLES',
      VALUABLE_TYPES: 'steps/modal/inputs/VALUABLE_TYPES',
      CORRECT_IN_CORRECT_VALUES: 'steps/modal/inputs/CORRECT_IN_CORRECT_VALUES',
      MARRIAGE_TERMINATION_REASON: 'steps/modal/inputs/MARRIAGE_TERMINATION_REASON',
      BENEFICIARY_CATEGORY: 'steps/modal/inputs/BENEFICIARY_CATEGORY',
      RELATIONSHIP_TYPE: 'steps/modal/inputs/RELATIONSHIP_TYPE',
      MERIDIEM_VALUES: 'steps/modal/inputs/MERIDIEM_VALUES',
      USER_SELECT: 'steps/modal/multiSelect/USER_SELECT',
      CARE_GIVER_SELECT: 'steps/modal/multiSelect/CARE_GIVER_SELECT',
      DATE_OF_WILL: 'steps/modal/inputs/DATE_OF_WILL',
      DATE_OF_CODICIL: 'steps/modal/inputs/DATE_OF_CODICIL',
      BANK_STATEMENT_UPLOAD: 'steps/modal/inputs/BANK_STATEMENT_UPLOAD',
      NOTICE_OF_ASSESSMENT_UPLOAD: 'steps/modal/inputs/NOTICE_OF_ASSESSMENT_UPLOAD',
      AFFIDAVIT_OF_PUBLICATION_UPLOAD:
        'GuidanceStepCypressAttribute:modal:inputs:AFFIDAVIT_OF_PUBLICATION_UPLOAD',
      NOTICE_OF_ASSESSMENT_AMOUNT: 'steps/modal/inputs/NOTICE_OF_ASSESSMENT_AMOUNT',
      HAS_GUARDIAN: 'steps/modal/inputs/HAS_GUARDIAN',
      ADD_CHILDREN: 'GuidanceStepCypressAttribute:modal:inputs:ADD_CHILDREN',
      ADD_PET: 'GuidanceStepCypressAttribute:modal:inputs:ADD_PET',
      AMOUNT_CURRENCY_DISPLAY_INPUT:
        'GuidanceStepCypressAttribute:modal:inputs:AMOUNT_CURRENCY_DISPLAY_INPUT',
      LUMP_SUM_GIFT_AMOUNT: 'GuidanceStepCypressAttribute:model:inputs:LUMP_SUM_GIFT_AMOUNT',
      ESTATE_ADMINISTRATION_LETTER_START_DATE:
        'steps/modal/inputs/ESTATE_ADMINISTRATION_LETTER_START_DATE',
      ESTATE_ADMINISTRATION_LETTER_END_DATE:
        'steps/modal/inputs/ESTATE_ADMINISTRATION_LETTER_END_DATE',
      CASE_NUMBER: 'GuidanceStepCypressAttribute:modal:inputs:CASE_NUMBER',
      HEARING_DATE: 'GuidanceStepCypressAttribute:modal:inputs:HEARING_DATE',
      HEARING_HOUR: 'GuidanceStepCypressAttribute:modal:inputs:HEARING_HOUR',
      HEARING_MINUTE: 'GuidanceStepCypressAttribute:modal:inputs:HEARING_MINUTE',
      DEPARTMENT: 'GuidanceStepCypressAttribute:modal:inputs:DEPARTMENT',
      ROOM: 'GuidanceStepCypressAttribute:modal:inputs:ROOM',
      CONTACT_HAS_ALIAS: 'GuidanceStepCypressAttribute:modal:inputs:CONTACT_HAS_ALIAS',
      PET_NAME: 'GuidanceStepCypressAttribute:modal:inputs:PET_NAME',
      PET_SPECIFY_SPECIES: 'GuidanceStepCypressAttribute:modal:inputs:PET_SPECIFY_SPECIES',
      PET_SPECIES_SELECT: 'GuidanceStepCypressAttribute:modal:inputs:PET_SPECIES_SELECT',
      HAS_CHILDREN: 'GuidanceStepCypressAttribute:modal:inputs:HAS_CHILDREN',
      HAS_CHILDREN_THAT_PREDECEASED_THEM:
        'GuidanceStepCypressAttribute:modal:inputs:HAS_CHILDREN_THAT_PREDECEASED_THEM',
      DID_THEY_HAVE_CHILDREN: 'GuidanceStepCypressAttribute:modal:inputs:DID_THEY_HAVE_CHILDREN',
      ESTATE_IS_ONGOING: 'GuidanceStepCypressAttribute:modal:inputs:ESTATE_IS_ONGOING',
      DATE_OF_DEATH: 'GuidanceStepCypressAttribute:modal:inputs:DATE_OF_DEATH',
      ESTATE_PROOF_OF_WILL_SEARCH:
        'GuidanceStepCypressAttribute:modal:inputs:ESTATE_PROOF_OF_WILL_SEARCH',
      ESTATE_PROOF_OF_WILL_SEARCH_WITH_CHAMBRE_DES_NOTAIRES:
        'GuidanceStepCypressAttribute:modal:inputs:ESTATE_PROOF_OF_WILL_SEARCH_WITH_CHAMBRE_DES_NOTAIRES',
      ESTATE_PROOF_OF_WILL_SEARCH_WITH_BARREAU_DU_QUEBEC:
        'GuidanceStepCypressAttribute:modal:inputs:ESTATE_PROOF_OF_WILL_SEARCH_WITH_BARREAU_DU_QUEBEC',
      COHABITATION_AGREEMENT: 'GuidanceStepCypressAttribute:modal:inputs:COHABITATION_AGREEMENT',
      SUCCESSOR_RELATIONSHIP_GROUP_BOX:
        'GuidanceStepCypressAttribute:modal:inputs:SUCCESSOR_RELATIONSHIP_GROUP_BOX',
      EIN: 'GuidanceStepCypressAttribute:modal:inputs:EIN',
      FULL_TIME_STUDENT: 'GuidanceStepCypressAttribute:modal:inputs:FULL_TIME_STUDENT'
    },
    buttons: {
      DISTRIBUTION_NO_LONGER_AVAILABLE_CONFIRM:
        'GuidanceStepCypressAttribute:modal:buttons:DISTRIBUTION_NO_LONGER_AVAILABLE_CONFIRM',
      SHOW_QUEBEC_CIVIL_CODE_INFORMATION_MODAL:
        'GuidanceStepCypressAttribute:modal:buttons:SHOW_QUEBEC_CIVIL_CODE_INFORMATION_MODAL',
      GO_TO_INBOX: 'GuidanceStepCypressAttribute:modal:buttons:GO_TO_INBOX',
      STAGE_COLLAPSE: 'steps/modal/buttons/STAGE_COLLAPSE',
      SHOW_ALL_STEPS: 'steps/modal/buttons/SHOW_ALL_STEPS',
      NOTIFY_STEP: 'steps/modal/buttons/NOTIFY_STEP',
      CONFIRM_VALUE: 'steps/modal/buttons/CONFIRM_VALUE',
      VALUE_CONFIRM: 'steps/modal/buttons/VALUE_CONFIRM',
      EDIT_FLOW_DETAIL_CARD: 'steps/modal/buttons/EDIT_FLOW_DETAIL_CARD',
      NOTICE_OF_ASSESSMENT_AMOUNT_OWING: 'steps/modal/inputs/NOTICE_OF_ASSESSMENT_UPLOAD',
      ESIGN_DOCUMENT_GENERIC_DISPLAY_CARD:
        'steps:modal:buttons:ESIGN_DOCUMENT_GENERIC_DISPLAY_CARD',
      DOCUMENT_GENERIC_DISPLAY_CARD: 'steps:modal:buttons:DOCUMENT_GENERIC_DISPLAY_CARD',
      DOCUMENT_GENERIC_DISPLAY_CARD_TITLE:
        'steps:modal:buttons:DOCUMENT_GENERIC_DISPLAY_CARD_TITLE',
      ADD_SPOUSE_BUTTON: 'steps:modal:buttons:ADD_SPOUSE_BUTTON',
      ADD_COMMON_LAW_BUTTON: 'steps:modal:buttons:ADD_COMMON_LAW_BUTTON',
      SELF_SERVE_UPGRADE_BUTTON: 'steps:modal:buttons:SELF_SERVE_UPGRADE_BUTTON',
      RESET_WILL: 'GuidanceStepCypressAttribute:modal:buttons:RESET_WILL',
      SHOW_PAY_WALL: 'GuidanceStepCypressAttribute:modal:buttons:SHOW_PAY_WALL',
      REVIEW_FINANCIALS: 'GuidanceStepCypressAttribute:modal:buttons:REVIEW_FINANCIALS',
      GUIDANCE_STEP_WIDGET_BUTTON:
        'GuidanceStepCypressAttribute:modal:buttons:GUIDANCE_STEP_WIDGET_BUTTON'
    },
    text: {
      COMPLETED_ESTATE: 'GuidanceStepCypressAttribute:modal:text:COMPLETED_ESTATE'
    }
  },
  pathAhead: {
    inputs: {
      PAYABLE_TO: 'steps/pathAhead/inputs/PAYABLE_TO',
      COURTHOUSE_FEE: 'steps/pathAhead/inputs/COURTHOUSE_FEE',
      COURTHOUSE_NAME: 'GuidanceStepCypressAttribute:inputs:COURTHOUSE_NAME',
      COURTHOUSE_BRANCH_NAME: 'GuidanceStepCypressAttribute:inputs:COURTHOUSE_BRANCH_NAME'
    },
    buttons: {
      REQUEST_SEARCH: 'GuidanceStepCypressAttribute:pathAhead:buttons:REQUEST_SEARCH'
    }
  },
  financialSituation: {
    views: {
      JOINT_OWNERSHIP: 'GuidanceStepCypressAttribute:financialSituation:views:JOINT_OWNERSHIP',
      JOINT_WITH_SURVIVORSHIP_RIGHT:
        'GuidanceStepCypressAttribute:financialSituation:views:JOINT_WITH_SURVIVORSHIP_RIGHT'
    },
    inputs: {
      BUSINESS_INTEREST: 'GuidanceStepCypressAttribute:financialSituation:inputs:BUSINESS_INTEREST'
    }
  },
  inventory: {
    buttons: {
      MARK_AS_UP_TO_DATE: 'GuidanceStepCypressAttribute:inventory:buttons:MARK_AS_UP_TO_DATE'
    }
  },
  distributionFramework: {
    views: {
      SUB_LABEL: 'GuidanceStepCypressAttribute:distributionFramework:views:SUB_LABEL',
      COMPLETE_BENEFICIARY_STEP_FORM:
        'GuidanceStepCypressAttribute:distributionFramework:views:COMPLETE_BENEFICIARY_STEP_FORM',
      WHO_IS_CONSIDERED:
        'GuidanceStepCypressAttribute:distributionFramework:views:WHO_IS_CONSIDERED',
      INVITE_BENEFICIARIES_BANNER_TEXT:
        'GuidanceStepCypressAttribute:distributionFramework:views:INVITE_BENEFICIARIES_BANNER_TEXT',
      INVITE_BENEFICIARIES_SELECTED_TEXT:
        'GuidanceStepCypressAttribute:distributionFramework:views:INVITE_BENEFICIARIES_SELECTED_TEXT',
      INVITE_BENEFICIARIES_DISTRIBUTION_TYPE:
        'GuidanceStepCypressAttribute:distributionFramework:views:INVITE_BENEFICIARIES_DISTRIBUTION_TYPE'
    }
  },
  funeralPreArrangements: {
    buttons: {},
    inputs: {
      FINAL_DISPOSITION: 'GuidanceStepCypressAttribute:inputs:FINAL_DISPOSITION',
      FINAL_DISPOSITION_NOTE: 'GuidanceStepCypressAttribute:inputs:FINAL_DISPOSITION_NOTE',
      SERVICE_TYPE: 'GuidanceStepCypressAttribute:inputs:SERVICE_TYPE',
      CEREMONY_TYPE: 'GuidanceStepCypressAttribute:inputs:CEREMONY_TYPE',
      CEREMONY_TYPE_NOTE: 'GuidanceStepCypressAttribute:inputs:CEREMONY_TYPE_NOTE',
      SPECIAL_REQUEST_NOTE: 'GuidanceStepCypressAttribute:inputs:SPECIAL_REQUEST_NOTE',
      hasFuneralPreArrangements:
        'GuidanceStepCypressAttribute:funeralPreArrangement:buttons:hasFuneralPreArrangements',
      FUNERAL_PREARRANGEMENT_ADDITIONAL_DETAILS:
        'GuidanceStepCypressAttribute:funeralPreArrangement:buttons:FUNERAL_PREARRANGEMENT_ADDITIONAL_DETAILS',
      hasCemeteryProperty:
        'GuidanceStepCypressAttribute:funeralPreArrangement:buttons:hasCemeteryProperty'
    },
    views: {}
  },
  probate: {
    inputs: {
      NOT_APPLICABLE: 'GuidanceStepCypressAttribute:probate:NOT_APPLICABLE',
      GENERIC_PROBATE_TAX_VALUE: 'GuidanceStepCypressAttribute:probate:GENERIC_PROBATE_TAX_VALUE',
      CALCULATION_EXPLANATION: 'GuidanceStepCypressAttribute:probate:CALCULATION_EXPLANATION',
      CHEQUE_RECIPIENT: 'GuidanceStepCypressAttribute:probate:CHEQUE_RECIPIENT',
      COMMISSION_PROCESS_TYPES: 'GuidanceStepCypressAttribute:probate:COMMISSION_PROCESS_TYPES',
      COVER_LETTER_DOCUMENT: 'GuidanceStepCypressAttribute:probate:COVER_LETTER_DOCUMENT',
      INSTRUCTIONS_DOCUMENT: 'GuidanceStepCypressAttribute:probate:INSTRUCTIONS_DOCUMENT',
      NOTICE_TO_LEGATEES_STATUS: 'GuidanceStepCypressAttribute:probate:NOTICE_TO_LEGATEES_STATUS',
      APPLICATION_STATUS: 'GuidanceStepCypressAttribute:probate:APPLICATION_STATUS',
      NOTICE_OF_LIQUIDTOR_DESIGNATION_STATUS:
        'GuidanceStepCypressAttribute:probate:NOTICE_OF_LIQUIDTOR_DESIGNATION_STATUS',
      COMMISSION_MEETING_DATE_TIME:
        'GuidanceStepCypressAttribute:probate:COMMISSION_MEETING_DATE_TIME',
      COMMISSION_MEETING_PARTNER_NAME:
        'GuidanceStepCypressAttribute:probate:COMMISSION_MEETING_PARTNER_NAME',
      COMMISSION_MEETING_PARTNER_ADDRESS:
        'GuidanceStepCypressAttribute:probate:COMMISSION_MEETING_PARTNER_ADDRESS',
      PROBATE_APPLICATION_STATUS_SELECT:
        'GuidanceStepCypressAttribute:probate:PROBATE_APPLICATION_STATUS_SELECT',
      PROBATE_APPLICATION_REJECTION_NOTE_TEXTAREA:
        'GuidanceStepCypressAttribute:probate:PROBATE_APPLICATION_REJECTION_NOTE_TEXTAREA',
      PROBATE_FORM_REJECT_NOTE_TEXTAREA:
        'GuidanceStepCypressAttribute:probate:PROBATE_FORM_REJECT_NOTE_TEXTAREA',
      INFORMATION_FORM_DOCUMENT: 'GuidanceStepCypressAttribute:probate:INFORMATION_FORM_DOCUMENT',
      UPLOAD_EXTRA_PROBATE_FORM: 'GuidanceStepCypressAttribute:probate:UPLOAD_EXTRA_PROBATE_FORM',
      SELECT_ALL_FORM: 'GuidanceStepCypressAttribute:probate:SELECT_ALL_FORM',
      SELECT_FORM: 'GuidanceStepCypressAttribute:probate:SELECT_FORM'
    },
    views: {
      COMMISSION_MEETING_DATE_TIME:
        'GuidanceStepCypressAttribute:probate:VIEW_COMMISSION_MEETING_DATE_TIME',
      ACTIVE_PROBATE_APPLICATION: 'GuidanceStepCypressAttribute:probate:ACTIVE_PROBATE_APPLICATION',
      INACTIVE_PROBATE_APPLICATION:
        'GuidanceStepCypressAttribute:probate:INACTIVE_PROBATE_APPLICATION',
      PROBATE_ESTATE_FORM_TEMPLATE:
        'GuidanceStepCypressAttribute:probate:PROBATE_ESTATE_FORM_TEMPLATE',
      PROBATE_TAX_LINE_ITEMS: 'GuidanceStepCypressAttribute:probate:PROBATE_TAX_LINE_ITEMS',
      PROFESSIONAL_HELPER_BOX: 'GuidanceStepCypressAttribute:probate:PROFESSIONAL_HELPER_BOX',
      CALCULATION_EXPLANATION_TEXT:
        'GuidanceStepCypressAttribute:probate:CALCULATION_EXPLANATION_TEXT',
      PROBATE_VALUE: 'GuidanceStepCypressAttribute:probate:PROBATE_VALUE',
      ADD_EXTRA_PROBATE_FORM: 'GuidanceStepCypressAttribute:probate:ADD_EXTRA_PROBATE_FORM',
      PROBATE_FORM_STATUS: 'GuidanceStepCypressAttribute:probate:PROBATE_FORM_STATUS',
      REJECT_PROBATE_FORM_NOTE: 'GuidanceStepCypressAttribute:probate:REJECT_PROBATE_FORM_NOTE'
    },
    buttons: {
      PAY_WITH_OWN_FUNDS: 'GuidanceStepCypressAttribute:probate:PAY_WITH_OWN_FUNDS',
      PAY_WITH_ESTATE_FUNDS: 'GuidanceStepCypressAttribute:probate:PAY_WITH_ESTATE_FUNDS',
      PROFESSIONAL_HELPER_BOX_BUTTON:
        'GuidanceStepCypressAttribute:probate:PROFESSIONAL_HELPER_BOX_BUTTON',
      PRINT_COVER_LETTER_DOCUMENT:
        'GuidanceStepCypressAttribute:probate:PRINT_COVER_LETTER_DOCUMENT',
      VIEW_INSTRUCTIONS_DOCUMENT: 'GuidanceStepCypressAttribute:probate:VIEW_INSTRUCTIONS_DOCUMENT',
      CONFIRM_COMMISSION_MEETING_BUTTON:
        'GuidanceStepCypressAttribute:probate:CONFIRM_COMMISSION_MEETING_BUTTON',
      VIEW_COMMISSIONED_DOCUMENTS:
        'GuidanceStepCypressAttribute:probate:VIEW_COMMISSIONED_DOCUMENTS',
      DOWNLOAD_COMMISSIONED_DOCUMENTS:
        'GuidanceStepCypressAttribute:probate:DOWNLOAD_COMMISSIONED_DOCUMENTS',
      MARK_AS_DONE_PROBATE_FORMS: 'GuidanceStepCypressAttribute:probate:MARK_AS_DONE_PROBATE_FORMS',
      REMOVE_PROBATE_FORM: 'GuidanceStepCypressAttribute:probate:REMOVE_PROBATE_FORM',
      RESTORE_PROBATE_FORM: 'GuidanceStepCypressAttribute:probate:RESTORE_PROBATE_FORM',
      GENERATE_PROBATE_FORM: 'GuidanceStepCypressAttribute:probate:GENERATE_PROBATE_FORM',
      SEND_FOR_REVIEW_PROBATE_FORM:
        'GuidanceStepCypressAttribute:probate:SEND_FOR_REVIEW_PROBATE_FORM',
      PROBATE_FORM_ACTION_DROP_DOWN:
        'GuidanceStepCypressAttribute:probate:PROBATE_FORM_ACTION_DROP_DOWN',
      PREVIEW_PROBATE_FORM: 'GuidanceStepCypressAttribute:probate:PREVIEW_PROBATE_FORM',
      DOWNLOAD_PROBATE_FORM: 'GuidanceStepCypressAttribute:probate:DOWNLOAD_PROBATE_FORM',
      UPLOAD_NEW_VERSION_PROBATE_FORM:
        'GuidanceStepCypressAttribute:probate:UPLOAD_NEW_VERSION_PROBATE_FORM',
      REJECT_PROBATE_FORM_NOTE_REPLY_IN_INBOX:
        'GuidanceStepCypressAttribute:probate:REJECT_PROBATE_FORM_NOTE_REPLY_IN_INBOX',
      REVIEW_PROBATE_FORM: 'GuidanceStepCypressAttribute:probate:REVIEW_PROBATE_FORM',
      VIEW_AND_EDIT_PROBATE_FORM: 'GuidanceStepCypressAttribute:probate:VIEW_AND_EDIT_PROBATE_FORM',
      REGENERATE_FORM: 'GuidanceStepCypressAttribute:probate:REGENERATE_FORM',
      SEND_SELECTED_FOR_REVIEW: 'GuidanceStepCypressAttribute:probate:SEND_SELECTED_FOR_REVIEW',
      MARK_AS_APPROVED: 'GuidanceStepCypressAttribute:probate:MARK_AS_APPROVED'
    }
  },
  estate_information_return: {
    inputs: {
      APPLICATION_STATUS: 'GuidanceStepCypressAttribute:probate:inputs:APPLICATION_STATUS',
      APPLICATION_STATUS_SELECT:
        'GuidanceStepCypressAttribute:probate:inputs:APPLICATION_STATUS_SELECT',
      FILE_UPLOAD: 'GuidanceStepCypressAttribute:probate:inputs:FILE_UPLOAD',
      CHECKBOX: 'GuidanceStepCypressAttribute:probate:inputs:CHECKBOX',
      DATE_SELECT: 'GuidanceStepCypressAttribute:probate:inputs:DATE_SELECT'
    }
  },
  protection_mandate: {
    buttons: {
      CAN_GENERATE: 'GuidanceStepCypressAttribute:protection_mandate:CAN_GENERATE'
    },
    inputs: {
      ESTATE_PROTECTION_MANDATE_SIGNED:
        'GuidanceStepCypressAttribute:protection_mandate:inputs:ESTATE_PROTECTION_MANDATE_SIGNED',
      ESTATE_PROTECTION_MANDATE:
        'GuidanceStepCypressAttribute:protection_mandate:inputs:ESTATE_PROTECTION_MANDATE',
      ESTATE_PROTECTION_MANDATE_SIGNED_LOCATION:
        'GuidanceStepCypressAttribute:protection_mandate:inputs:ESTATE_PROTECTION_MANDATE_SIGNED_LOCATION'
    },
    views: {
      NO_PROTECTION_MANDATE_BANNER:
        'GuidanceStepCypressAttribute:protection_mandate:views:NO_PROTECTION_MANDATE_BANNER'
    }
  },
  will_and_poas: {
    buttons: {
      WILL_RESEND_NEW_VERSION:
        'GuidanceStepCypressAttribute:will_and_poas:buttons:WILL_RESEND_NEW_VERSION',
      SECONDARY_WILL_RESEND_NEW_VERSION:
        'GuidanceStepCypressAttribute:will_and_poas:buttons:SECONDARY_WILL_RESEND_NEW_VERSION',
      DOWNLOAD_WILL_DOCUMENT: 'GuidanceStepCypressAttribute:DOWNLOAD_WILL_DOCUMENT',
      DOWNLOAD_PROOF_OF_WILL_DOCUMENT:
        'GuidanceStepCypressAttribute:DOWNLOAD_PROOF_OF_WILL_DOCUMENT',
      DOWNLOAD_AFFIDAVIT_OF_EXECUTION_DOCUMENT:
        'GuidanceStepCypressAttribute:DOWNLOAD_AFFIDAVIT_OF_EXECUTION_DOCUMENT',
      WILL_GUIDE_INSTRUCTIONS: 'GuidanceStepCypressAttribute:WILL_GUIDE_INSTRUCTIONS',
      ADD_NEED: 'GuidanceStepCypressAttribute:ADD_NEED',
      VIEW_FINAL_WILL: 'GuidanceStepCypressAttribute:VIEW_FINAL_WILL',
      COMBINE_INTO_FINAL_WILL: 'GuidanceStepCypressAttribute:COMBINE_INTO_FINAL_WILL',
      SEND_TO_PARTNER: 'GuidanceStepCypressAttribute:SEND_TO_PARTNER',
      UNSEND_TO_PARTNER: 'GuidanceStepCypressAttribute:UNSEND_TO_PARTNER',
      DOCUMENT_FOR_COMBINED_FINAL_WILL:
        'GuidanceStepCypressAttribute:DOCUMENT_FOR_COMBINED_FINAL_WILL',
      DOCUMENT_FOR_SENDING_TO_PARTNER:
        'GuidanceStepCypressAttribute:DOCUMENT_FOR_SENDING_TO_PARTNER',
      DOCUMENT_FOR_SENDING_TO_PLANNER:
        'GuidanceStepCypressAttribute:DOCUMENT_FOR_SENDING_TO_PLANNER',
      SET_REMINDER: 'GuidanceStepCypressAttribute:will_and_poas:buttons:SET_REMINDER'
    },
    inputs: {
      CAN_GENERATE: 'GuidanceStepCypressAttribute:CAN_GENERATE',
      KEPT_IN_LIFE_SUPPORT: 'GuidanceStepCypressAttribute:KEPT_IN_LIFE_SUPPORT',
      HAS_INCURABLE_CONDITION: 'GuidanceStepCypressAttribute:HAS_INCURABLE_CONDITION',
      IS_PERMANENTLY_UNCONSCIOUS: 'GuidanceStepCypressAttribute:IS_PERMANENTLY_UNCONSCIOUS',
      IS_COMPENSATION_REQUIRED: 'GuidanceStepCypressAttribute:IS_COMPENSATION_REQUIRED',
      CONDITIONS_RESTRICTIONS: 'GuidanceStepCypressAttribute:CONDITIONS_RESTRICTIONS',
      DO_TREATMENTS_OUTWEIGH_BENEFITS:
        'GuidanceStepCypressAttribute:DO_TREATMENTS_OUTWEIGH_BENEFITS',
      SHOULD_RECEIVE_NUTRITION: 'GuidanceStepCypressAttribute:SHOULD_RECEIVE_NUTRITION',
      SHOULD_RECEIVE_PAIN_MEDICATION: 'GuidanceStepCypressAttribute:SHOULD_RECEIVE_PAIN_MEDICATION',
      MEDICATION_CIRCUMSTANCES: 'GuidanceStepCypressAttribute:MEDICATION_CIRCUMSTANCES',
      SHOULD_DONATE_ORGANS: 'GuidanceStepCypressAttribute:SHOULD_DONATE_ORGANS',
      ORGAN_DONATION_PURPOSES: 'GuidanceStepCypressAttribute:ORGAN_DONATION_PURPOSES',
      ORGAN_SELECTION_TYPE: 'GuidanceStepCypressAttribute:ORGAN_SELECTION_TYPE',
      ORGAN_SPECIFIC_CONDITIONS: 'GuidanceStepCypressAttribute:ORGAN_SPECIFIC_CONDITIONS',
      CAN_DISPOSE_REMAINS: 'GuidanceStepCypressAttribute:CAN_DISPOSE_REMAINS',
      CAN_CONSENT_AUTOPSY: 'GuidanceStepCypressAttribute:CAN_CONSENT_AUTOPSY',
      HEALTH_CARE_RESTRICTIONS: 'GuidanceStepCypressAttribute:HEALTH_CARE_RESTRICTIONS',
      ESTATE_POWER_OF_ATTORNEY_SIGNED:
        'GuidanceStepCypressAttribute:ESTATE_POWER_OF_ATTORNEY_SIGNED',
      ESTATE_POWER_OF_ATTORNEY_SIGNED_LOCATION:
        'GuidanceStepCypressAttribute:ESTATE_POWER_OF_ATTORNEY_SIGNED_LOCATION',
      ESTATE_PROOF_OF_WILL_DOCUMENT_SIGNED:
        'GuidanceStepCypressAttribute:ESTATE_PROOF_OF_WILL_DOCUMENT_SIGNED',
      ESTATE_WILL_AND_PROOF_OF_WILL_LOCATION:
        'GuidanceStepCypressAttribute:ESTATE_WILL_AND_PROOF_OF_WILL_LOCATION',
      ESTATE_AFFIDAVIT_OF_EXECUTION_DOCUMENT_SIGNED:
        'GuidanceStepCypressAttribute:AFFIDAVIT_OF_EXECUTION_DOCUMENT',
      ESTATE_WILL_AND_AFFIDAVIT_OF_EXECUTION_LOCATION:
        'GuidanceStepCypressAttribute:ESTATE_WILL_AND_AFFIDAVIT_OF_EXECUTION_LOCATION',
      ESTATE_WILL: 'GuidanceStepCypressAttribute:ESTATE_WILL',
      ESTATE_WILL_SIGNED: 'GuidanceStepCypressAttribute:ESTATE_WILL_SIGNED',
      PRIMARY_ATTORNEY_ACT_TYPE: 'GuidanceStepCypressAttribute:PRIMARY_ATTORNEY_ACT_TYPE',
      HAS_ADDITIONAL_NEEDS: 'GuidanceStepCypressAttribute:HAS_ADDITIONAL_NEEDS',
      FINAL_UPLOADED_WILL_DOCUMENT: 'GuidanceStepCypressAttribute:FINAL_UPLOADED_WILL_DOCUMENT',
      ESTATE_WILL_ESTATE_PROFESSIONAL_EDITED_DOCX:
        'GuidanceStepCypressAttribute:ESTATE_WILL_ESTATE_PROFESSIONAL_EDITED_DOCX',
      WILL_CONSENT_CHECKBOX: 'GuidanceStepCypressAttribute:WILL_CONSENT_CHECKBOX',
      DATE_SIGNED: 'GuidanceStepCypressAttribute:DATE_SIGNED',
      AFFIDAVIT_DATE_SIGNED: 'GuidanceStepCypressAttribute:AFFIDAVIT_DATE_SIGNED',
      PROOF_OF_WILL_DATE_SIGNED: 'GuidanceStepCypressAttribute:PROOF_OF_WILL_DATE_SIGNED',
      PROTECTION_MANDATE_CONSENT_CHECKBOX:
        'GuidanceStepCypressAttribute:PROTECTION_MANDATE_CONSENT_CHECKBOX',
      UPLOAD_EXISTING_POWER_OF_ATTORNEY:
        'GuidanceStepCypressAttribute:UPLOAD_EXISTING_POWER_OF_ATTORNEY',
      REMINDER_DATE: 'GuidanceStepCypressAttribute:will_and_poas:inputs:REMINDER_DATE'
    },
    views: {
      EMPTY_STATE: 'GuidanceStepCypressAttribute:EMPTY_STATE',
      DOCUMENT_GENERATION_IN_PROGRESS:
        'GuidanceStepCypressAttribute:DOCUMENT_GENERATION_IN_PROGRESS',
      DOCUMENT_GENERATION_IN_PROGRESS_CUSTOM_TITLE:
        'GuidanceStepCypressAttribute:will_and_poas:views:DOCUMENT_GENERATION_IN_PROGRESS_CUSTOM_TITLE',
      PLATFORM_GENERATED_WILL: 'GuidanceStepCypressAttribute:PLATFORM_GENERATED_WILL',
      COMBINE_INTO_FINAL_WILL_COLLAPSE:
        'GuidanceStepCypressAttribute:COMBINE_INTO_FINAL_WILL_COLLAPSE',
      POWER_OF_ATTORNEY_INFORMATION_SECTION:
        'GuidanceStepCypressAttribute:POWER_OF_ATTORNEY_INFORMATION_SECTION',
      PRIMARY_ATTORNEY_BANNER: 'GuidanceStepCypressAttribute:views:PRIMARY_ATTORNEY_BANNER',
      SUBSTITUTE_ATTORNEY_BANNER: 'GuidanceStepCypressAttribute:views:SUBSTITUTE_ATTORNEY_BANNER',
      SEND_TO_PARTNER_COLLAPSE: 'GuidanceStepCypressAttribute:SEND_TO_PARTNER_COLLAPSE',
      SEND_TO_PARTNER_TOOLTIP: 'GuidanceStepCypressAttribute:SEND_TO_PARTNER_TOOLTIP',
      SENT_TO_PARTNER_BANNER: 'GuidanceStepCypressAttribute:SENT_TO_PARTNER_BANNER',
      WILL_COVER_PAGE: 'GuidanceStepCypressAttribute:WILL_COVER_PAGE',
      WILL_COVER_SHEET: 'GuidanceStepCypressAttribute:WILL_COVER_SHEET',
      WILL_DOCX: 'GuidanceStepCypressAttribute:WILL_DOCX',
      WILL_EDITED: 'GuidanceStepCypressAttribute:WILL_EDITED',
      WILL_FINAL: 'GuidanceStepCypressAttribute:WILL_FINAL',
      SECONDARY_WILL_HELP_ICON:
        'GuidanceStepCypressAttribute:will_and_poas:views:SECONDARY_WILL_HELP_ICON',
      SECONDARY_WILL_CHANGES_REQUESTED_BANNER:
        'GuidanceStepCypressAttribute:will_and_poas:views:SECONDARY_WILL_CHANGES_REQUESTED_BANNER',
      WILL_EXTRA_INFORMATION: 'GuidanceStepCypressAttribute:WILL_EXTRA_INFORMATION',
      WILL_DOCX_TO_SEND_TO_PARTNER:
        'GuidanceStepCypressAttribute:will_and_poas:views:WILL_DOCX_TO_SEND_TO_PARTNER',
      CONTINUE_TO_SECTION: 'GuidanceStepCypressAttribute:will_and_poas:views:CONTINUE_TO_SECTION'
    }
  },
  clearWill: {
    modal: {
      PERSONAL_INFORMATION_STAGE_COMPLETE_MODAL:
        'GuidanceStepCypressAttribute:clearWill:modal:PERSONAL_INFORMATION_STAGE_COMPLETE_MODAL',
      EXECUTORSHIP_STAGE_COMPLETE_MODAL:
        'GuidanceStepCypressAttribute:clearWill:modal:EXECUTORSHIP_STAGE_COMPLETE_MODAL',
      PERSONAL_INFORMATION_UPSELL:
        'GuidanceStepCypressAttribute:clearWill:modal:PERSONAL_INFORMATION_UPSELL'
    }
  },
  fileTaxes: {
    buttons: {
      CRA_ACCESS_ON_HOLD: 'GuidanceStepCypressAttribute:fileTaxes:buttons:CRA_ACCESS_ON_HOLD',
      REVENUE_AGENCY_REQUEST:
        'GuidanceStepCypressAttribute:fileTaxes:buttons:REVENUE_AGENCY_REQUEST',
      REVENUE_AGENCY_REQUEST_STATUS:
        'GuidanceStepCypressAttribute:fileTaxes:buttons:REVENUE_AGENCY_REQUEST_STATUS'
    }
  },
  personalInformation: {
    buttons: {
      VAULT_EXTRA_INFORMATION_RADIO:
        'GuidanceStepCypressAttribute:personalInformation:buttons:VAULT_EXTRA_INFORMATION_RADIO',
      VAULT_EXTRA_INFORMATION_WILL_OR_POA_BUTTON:
        'GuidanceStepCypressAttribute:personalInformation:buttons:VAULT_EXTRA_INFORMATION_WILL_OR_POA_BUTTON'
    },
    inputs: {
      VAULT_EXTRA_INFORMATION_INPUT:
        'GuidanceStepCypressAttribute:personalInformation:inputs:VAULT_EXTRA_INFORMATION_INPUT'
    },
    views: {
      FORM_MULTIPLE_UPLOAD_OR_SELECT:
        'GuidanceStepCypressAttribute:personalInformation:inputs:FORM_MULTIPLE_UPLOAD_OR_SELECT',
      VAULT_EXTRA_INFORMATION:
        'GuidanceStepCypressAttribute:personalInformation:inputs:VAULT_EXTRA_INFORMATION',
      GUARDIAN_USER_FORM:
        'GuidanceStepCypressAttribute:personalInformation:views:GUARDIAN_USER_FORM'
    }
  },
  estateInterimDistribution: {
    buttons: {
      INVITE_BENEFICIARIES:
        'GuidanceStepCypressAttribute:estateInterimDistribution:buttons:INVITE_BENEFICIARIES',
      RESEND_INVITE: 'GuidanceStepCypressAttribute:estateInterimDistribution:buttons:RESEND_INVITE',
      BENEFICIARY_DISAGREE_WITH_DISTRIBUTION:
        'GuidanceStepCypressAttribute:estateInterimDistribution:buttons:BENEFICIARY_DISAGREE_WITH_DISTRIBUTION',
      DOWNLOAD_BANKING_INFORMATION_PDF:
        'GuidanceStepCypressAttribute:estateInterimDistribution:buttons:DOWNLOAD_BANKING_INFORMATION_PDF'
    },
    views: {
      ACCOUNTING_DETAILS_COLLAPSE:
        'GuidanceStepCypressAttribute:estateInterimDistribution:views:ACCOUNTING_DETAILS_COLLAPSE',
      DISTRIBUTION_LIST:
        'GuidanceStepCypressAttribute:estateInterimDistribution:views:DISTRIBUTION_LIST',
      DISTRIBUTION_LIST_ITEMS:
        'GuidanceStepCypressAttribute:estateInterimDistribution:views:DISTRIBUTION_LIST_ITEMS',
      DISTRIBUTION_LIST_COLLAPSE:
        'GuidanceStepCypressAttribute:estateInterimDistribution:views:DISTRIBUTION_LIST_COLLAPSE'
    }
  },
  finalizeInventoryValue: {
    buttons: {
      CONFIRM_PROBATE_REFEREE_FEE:
        'GuidanceStepCypressAttribute:finalizeInventoryValue:buttons:CONFIRM_PROBATE_REFEREE_FEE',
      MARK_AS_PAID: 'GuidanceStepCypressAttribute:finalizeInventoryValue:buttons:MARK_AS_PAID',
      APPROVE_ENVELOPE:
        'GuidanceStepCypressAttribute:finalizeInventoryValue:buttons:APPROVE_ENVELOPE',
      DOWNLOAD_ENVELOPE:
        'GuidanceStepCypressAttribute:finalizeInventoryValue:buttons:DOWNLOAD_ENVELOPE',
      ENVELOPE_WAITING_FOR_APPROVAL:
        'GuidanceStepCypressAttribute:finalizeInventoryValue:buttons:ENVELOPE_WAITING_FOR_APPROVAL'
    },
    inputs: {
      NOTIFIED_COURT: 'GuidanceStepCypressAttribute:finalizeInventoryValue:inputs:NOTIFIED_COURT',
      FORM_RETURNED_BY_PROBATE_REFEREE:
        'GuidanceStepCypressAttribute:finalizeInventoryValue:inputs:FORM_RETURNED_BY_PROBATE_REFEREE',
      ASSET_FINAL_APPRAISED_VALUE:
        'GuidanceStepCypressAttribute:finalizeInventoryValue:inputs:ASSET_FINAL_APPRAISED_VALUE',
      PROBATE_REFEREE_FEE_NOT_APPLICABLE:
        'GuidanceStepCypressAttribute:finalizeInventoryValue:inputs:PROBATE_REFEREE_FEE_NOT_APPLICABLE',
      PROBATE_REFEREE_INVOICE_UPLOAD:
        'GuidanceStepCypressAttribute:finalizeInventoryValue:inputs:PROBATE_REFEREE_INVOICE_UPLOAD',
      PROBATE_REFEREE_FEE_AMOUNT:
        'GuidanceStepCypressAttribute:finalizeInventoryValue:inputs:PROBATE_REFEREE_FEE_AMOUNT',
      COVER_LETTER_INVENTORY_AND_APPRAISAL_UPLOAD:
        'GuidanceStepCypressAttribute:finalizeInventoryValue:inputs:COVER_LETTER_INVENTORY_AND_APPRAISAL_UPLOAD'
    },
    views: {
      EDUCATIONAL_NOTE: 'GuidanceStepCypressAttribute:finalizeInventoryValue:views:EDUCATIONAL_NOTE'
    }
  },
  notifyCreditors: {
    views: {
      CREDITOR_CLAIMS_COLLAPSE_DE_174:
        'GuidanceStepCypressAttribute:notifyCreditors:views:CREDITOR_CLAIMS_COLLAPSE_DE_174',
      COURTHOUSE_NOTIFICATION_CARD:
        'GuidanceStepCypressAttribute:notifyCreditors:views:COURTHOUSE_NOTIFICATION_CARD',
      INSTRUCTIONS: 'GuidanceStepCypressAttribute:notifyCreditors:views:INSTRUCTIONS',
      ESIGN_DOCUMENT_CARD: 'GuidanceStepCypressAttribute:notifyCreditors:views:ESIGN_DOCUMENT_CARD',
      TEMPLATE_DOCUMENT_CARD:
        'GuidanceStepCypressAttribute:notifyCreditors:views:TEMPLATE_DOCUMENT_CARD',
      TEMPLATE_NOT_APPROVED_BANNER:
        'GuidanceStepCypressAttribute:notifyCreditors:views:TEMPLATE_NOT_APPROVED_BANNER'
    },
    buttons: {
      DOWNLOAD_NOTIFY_INSTRUCTIONS:
        'GuidanceStepCypressAttribute:notifyCreditors:buttons:DOWNLOAD_NOTIFY_INSTRUCTIONS'
    }
  },
  notify: {
    views: {
      ESIGN_ENVELOPE_COLLAPSE: 'GuidanceStepCypressAttribute:notify:views:ESIGN_ENVELOPE_COLLAPSE',
      MOTHERS_BIRTH_SURNAME_TEXT:
        'GuidanceStepCypressAttribute:notify:inputs:MOTHERS_BIRTH_SURNAME_TEXT',
      ELIGIBILITY_FOR_FAMILY_ALLOWANCES_CTB:
        'GuidanceStepCypressAttribute:notify:views:ELIGIBILITY_FOR_FAMILY_ALLOWANCES_CTB',
      ALIAS_NAME_SUBLABEL: 'GuidanceStepCypressAttribute:notify:views:ALIAS_NAME_SUBLABEL',
      GRAND_CHILDREN_OPTION: 'GuidanceStepCypressAttribute:notify:views:GRAND_CHILDREN_OPTION',
      APPOINTMENT_LAW_BANNER: 'GuidanceStepCypressAttribute:notify:views:APPOINTMENT_LAW_BANNER',
      APPOINTMENT_LAW_BANNER_TITLE:
        'GuidanceStepCypressAttribute:notify:views:APPOINTMENT_LAW_BANNER_TITLE',
      NO_WILLING_ENTITLED_PERSON_EDUCATION:
        'GuidanceStepCypressAttribute:notify:views:NO_WILLING_ENTITLED_PERSON_EDUCATION',
      NEXT_OF_KIN_LAW_BANNER: 'GuidanceStepCypressAttribute:notify:views:NEXT_OF_KIN_LAW_BANNER',
      LIST_ALL_NEXT_OF_KIN_SECTION_TITLE:
        'GuidanceStepCypressAttribute:notify:views:LIST_ALL_NEXT_OF_KIN_SECTION_TITLE',
      PERSONAL_REPRESENTATIVE_LAW_BANNER:
        'GuidanceStepCypressAttribute:notify:views:PERSONAL_REPRESENTATIVE_LAW_BANNER',
      PREDECEASED_CHILD_WTIH_CHILDREN_SECTION:
        'GuidanceStepCypressAttribute:notify:views:PREDECEASED_CHILD_WTIH_CHILDREN_SECTION',
      PREDECEASED_KIN_WTIH_CHILDREN_SECTION:
        'GuidanceStepCypressAttribute:notify:views:PREDECEASED_KIN_WTIH_CHILDREN_SECTION',
      REMOVE_PERSONAL_REPRESENTATIVE_TOOLTIP:
        'GuidanceStepCypressAttribute:notify:views:REMOVE_PERSONAL_REPRESENTATIVE_TOOLTIP',
      REQUIRED_KIN_SECTION: 'GuidanceStepCypressAttribute:notify:views:REQUIRED_KIN_SECTION',
      VALIDATE_PRIMARY_EXECUTORS_SECTION:
        'GuidanceStepCypressAttribute:notify:views:VALIDATE_PRIMARY_EXECUTORS_SECTION',
      VALIDATE_ALTERNATE_EXECUTORS_SECTION:
        'GuidanceStepCypressAttribute:notify:views:VALIDATE_ALTERNATE_EXECUTORS_SECTION',
      VALIDATE_ENTITLED_NEXT_OF_KIN_SECTION:
        'GuidanceStepCypressAttribute:notify:views:VALIDATE_ENTITLED_NEXT_OF_KIN_SECTION',
      REVIEW_DECEASED_INFORMATION_COLLAPSE:
        'GuidanceStepCypressAttribute:notify:views:REVIEW_DECEASED_INFORMATION_COLLAPSE',
      REVIEW_EMPLOYMENT_SITUATION_COLLAPSE:
        'GuidanceStepCypressAttribute:notify:views:REVIEW_EMPLOYMENT_SITUATION_COLLAPSE',
      REVIEW_SPOUSE_INFORMATION_COLLAPSE:
        'GuidanceStepCypressAttribute:notify:views:REVIEW_SPOUSE_INFORMATION_COLLAPSE',
      REVIEW_COMMON_LAW_PARTNER_INFORMATION_COLLAPSE:
        'GuidanceStepCypressAttribute:notify:views:REVIEW_COMMON_LAW_PARTNER_INFORMATION_COLLAPSE',
      REVIEW_FORMER_SPOUSES_INFORMATION_COLLAPSE:
        'GuidanceStepCypressAttribute:notify:views:REVIEW_FORMER_SPOUSES_INFORMATION_COLLAPSE',
      REVIEW_CHILDREN_INFORMATION_COLLAPSE:
        'GuidanceStepCypressAttribute:notify:views:REVIEW_CHILDREN_INFORMATION_COLLAPSE',
      REVIEW_PREDECEASED_CHILDREN_INFORMATION_COLLAPSE:
        'GuidanceStepCypressAttribute:notify:views:REVIEW_PREDECEASED_CHILDREN_INFORMATION_COLLAPSE',
      REVIEW_NEXT_OF_KIN_INFORMATION_COLLAPSE:
        'GuidanceStepCypressAttribute:notify:views:REVIEW_NEXT_OF_KIN_INFORMATION_COLLAPSE',
      REVIEW_ACTING_REPRESENTATIVE_INFORMATION_COLLAPSE:
        'GuidanceStepCypressAttribute:notify:views:REVIEW_ACTING_REPRESENTATIVE_INFORMATION_COLLAPSE',
      REVIEW_OTHER_ENTITLED_REPRESENTATIVE_INFORMATION_COLLAPSE:
        'GuidanceStepCypressAttribute:notify:views:REVIEW_OTHER_ENTITLED_REPRESENTATIVE_INFORMATION_COLLAPSE',
      IMMEDIATE_FAMILY_ITEM: 'GuidanceStepCypressAttribute:notify:views:IMMEDIATE_FAMILY_ITEM',
      PREDECEASED_BY_SECTION: 'GuidanceStepCypressAttribute:notify:views:PREDECEASED_BY_SECTION',
      EMPTY_TABLE: 'GuidanceStepCypressAttribute:notify:views:EMPTY_TABLE'
    },
    inputs: {
      HAS_UNKNOWN_MOTHER_CHECKBOX:
        'GuidanceStepCypressAttribute:notify:inputs:HAS_UNKNOWN_MOTHER_CHECKBOX',
      MOTHERS_BIRTH_SURNAME: 'GuidanceStepCypressAttribute:notify:inputs:MOTHERS_BIRTH_SURNAME',
      APPLIED_FOR_CPP: 'GuidanceStepCypressAttribute:notify:inputs:APPLIED_FOR_CPP',
      APPLIED_FOR_QPP: 'GuidanceStepCypressAttribute:notify:inputs:APPLIED_FOR_QPP',
      APPLIED_FOR_OAS: 'GuidanceStepCypressAttribute:notify:inputs:APPLIED_FOR_OAS',
      LIVED_OR_WORKED_OUTSIDE_CANADA:
        'GuidanceStepCypressAttribute:notify:inputs:LIVED_OR_WORKED_OUTSIDE_CANADA',
      ENGAGED_WORK_OUTSIDE_USA:
        'GuidanceStepCypressAttribute:notify:inputs:ENGAGED_WORK_OUSTIDE_USA',
      DECEASED_ELIGIBLE_FOR_FAMILY_ALLOWANCES_CTB:
        'GuidanceStepCypressAttribute:notify:inputs:DECEASED_ELIGIBLE_FOR_FAMILY_ALLOWANCES_CTB',
      SPOUSE_ELIGIBLE_FOR_FAMILY_ALLOWANCES_CTB:
        'GuidanceStepCypressAttribute:notify:inputs:SPOUSE_ELIGIBLE_FOR_FAMILY_ALLOWANCES_CTB',
      NOK_RELATIONSHIP_CHECKBOX_GROUP:
        'GuidanceStepCypressAttribute:notify:inputs:NOK_RELATIONSHIP_CHECKBOX_GROUP',
      OTHER_KINSHIP_MULTISELECT:
        'GuidanceStepCypressAttribute:notify:inputs:OTHER_KINSHIP_MULTISELECT',
      OTHER_RESIDENCY_COUNTRY: 'GuidanceStepCypressAttribute:notify:inputs:OTHER_RESIDENCY_COUNTRY',
      INSURANCE_NUMBER: 'GuidanceStepCypressAttribute:notify:inputs:INSURANCE_NUMBER',
      HAS_REQUESTED_BENEFITS: 'GuidanceStepCypressAttribute:notify:inputs:HAS_REQUESTED_BENEFITS',
      WILL_ACT: 'GuidanceStepCypressAttribute:notify:inputs:WILL_ACT',
      UNABLE_TO_ACT: 'GuidanceStepCypressAttribute:notify:inputs:UNABLE_TO_ACT',
      WISHES_TO_RENOUNCE: 'GuidanceStepCypressAttribute:notify:inputs:WISHES_TO_RENOUNCE',
      REASON_FOR_EXECUTORSHIP: 'GuidanceStepCypressAttribute:notify:inputs:REASON_FOR_EXECUTORSHIP',
      OTHER_REASON_FOR_EXECUTORSHIP:
        'GuidanceStepCypressAttribute:notify:inputs:OTHER_REASON_FOR_EXECUTORSHIP',
      MARRIAGE_CERTIFICATE_NOTE:
        'GuidanceStepCypressAttribute:notify:views:MARRIAGE_CERTIFICATE_NOTE'
    },
    buttons: {
      ADD_COUNTRY: 'GuidanceStepCypressAttribute:notify:buttons:ADD_COUNTRY',
      EDIT_NEXT_OF_KIN: 'GuidanceStepCypressAttribute:notify:buttons:EDIT_NEXT_OF_KIN',
      EDIT_PERSONAL_REPRESENTATIVE:
        'GuidanceStepCypressAttribute:notify:buttons:EDIT_PERSONAL_REPRESENTATIVE',
      REMOVE_NEXT_OF_KIN: 'GuidanceStepCypressAttribute:notify:buttons:REMOVE_NEXT_OF_KIN',
      REMOVE_PERSONAL_REPRESENTATIVE:
        'GuidanceStepCypressAttribute:notify:buttons:REMOVE_PERSONAL_REPRESENTATIVE',
      ADD_NEXT_OF_KIN: 'GuidanceStepCypressAttribute:notify:buttons:ADD_NEXT_OF_KIN',
      GO_TO_ADMIN_INBOX: 'GuidanceStepCypressAttribute:notify:buttons:GO_TO_ADMIN_INBOX'
    }
  },
  estateInstitution: {
    buttons: {
      ADD_ASSET: 'GuidanceStepCypressAttribute:estateInstitution:buttons:ADD_ASSET',
      ADD_LIABILITY: 'GuidanceStepCypressAttribute:estateInstitution:buttons:ADD_LIABILITY',
      DELETE_INSTITUTION:
        'GuidanceStepCypressAttribute:estateInstitution:buttons:DELETE_INSTITUTION',
      DELETE_LINKED_ACCOUNT:
        'GuidanceStepCypressAttribute:estateInstitution:buttons:DELETE_LINKED_ACCOUNT',
      GENERATE_LETTER: 'GuidanceStepCypressAttribute:estateInstitution:buttons:GENERATE_LETTER',
      REGENERATE_LETTER: 'GuidanceStepCypressAttribute:estateInstitution:buttons:REGENERATE_LETTER',
      EDIT_ADDRESS: 'GuidanceStepCypressAttribute:estateInstitution:buttons:EDIT_ADDRESS',
      CONFIRM_ADDRESS: 'GuidanceStepCypressAttribute:estateInstitution:buttons:CONFIRM_ADDRESS',
      CANCEL_ADDRESS: 'GuidanceStepCypressAttribute:estateInstitution:buttons:CANCEL_ADDRESS',
      ADD_INSTITUTION: 'GuidanceStepCypressAttribute:estateInstitution:buttons:ADD_INSTITUTION'
    },
    inputs: {
      INSTITUTION_MULTI_SELECT:
        'GuidanceStepCypressAttribute:estateInstitution:inputs:INSTITUTION_MULTI_SELECT',
      NOTIFIED_CHECKBOX: 'GuidanceStepCypressAttribute:estateInstitution:inputs:NOTIFIED_CHECKBOX',
      HAS_ACCOUNTS_RADIO:
        'GuidanceStepCypressAttribute:estateInstitution:inputs:HAS_ACCOUNTS_RADIO',
      ACCOUNTS_LOCATION_RADIO:
        'GuidanceStepCypressAttribute:estateInstitution:inputs:ACCOUNTS_LOCATION_RADIO'
    }
  },
  assetLiquidation: {
    inputs: {
      COURT_FILE_NUMBER: 'GuidanceStepCypressAttribute:assetLiquidation:inputs:COURT_FILE_NUMBER',
      PROBATE_GRANTED_DATE:
        'GuidanceStepCypressAttribute:assetLiquidation:inputs:PROBATE_GRANTED_DATE'
    }
  },
  employmentDetails: {
    inputs: {
      JOB_TITLE: 'GuidanceStepCypressAttribute:employmentDetails:inputs:JOB_TITLE',
      EMPLOYER: 'GuidanceStepCypressAttribute:employmentDetails:inputs:EMPLOYER',
      WAS_EMPLOYED: 'GuidanceStepCypressAttribute:employmentDetails:inputs:WAS_EMPLOYED',
      WAS_RETIRED: 'GuidanceStepCypressAttribute:employmentDetails:inputs:WAS_RETIRED',
      WAS_SELF_EMPLOYED: 'GuidanceStepCypressAttribute:employmentDetails:inputs:WAS_SELF_EMPLOYED',
      WAS_UNEMPLOYED: 'GuidanceStepCypressAttribute:employmentDetails:inputs:WAS_UNEMPLOYED',
      WAS_MILITARY_MEMBER:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:WAS_MILITARY_MEMBER',
      WAS_MILITARY_VETERAN:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:WAS_MILITARY_VETERAN',
      WAS_FEDERAL_EMPLOYEE:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:WAS_FEDERAL_EMPLOYEE',
      MILITARY_SERVICE_STATUS:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:MILITARY_SERVICE_STATUS',
      DIED_ON_ACTIVE_DUTY:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:DIED_ON_ACTIVE_DUTY',
      DIED_ON_INACTIVE_DUTY:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:DIED_ON_INACTIVE_DUTY',
      DIED_FROM_SERVICE_INJURY:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:DIED_FROM_SERVICE_INJURY',
      DIED_RECEIVING_CARE:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:DIED_WHILE_RECEIVING_CARE',
      DIED_RECEIVING_COMPENSATION:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:DIED_WHILE_RECEIVING_COMPENSATION',
      DIED_WHILE_PUBLIC_OFFICER:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:DIED_WHILE_PUBLIC_OFFICER',
      WAS_COAL_INDUSTRY_WORKER:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:WAS_COAL_INDUSTRY_WORKER',
      DIED_FROM_PNEUMOCONIOSIS:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:DIED_FROM_PNEUMOCONIOSIS',
      DIED_RECEIVING_EMPLOYMENT_INSURANCE:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:DIED_RECEIVING_EMPLOYMENT_INSURANCE',
      DIED_ELIGIBLE_FOR_BUT_NOT_RECEIVING_EMPLOYMENT_INSURANCE:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:DIED_ELIGIBLE_FOR_BUT_NOT_RECEIVING_EMPLOYMENT_INSURANCE',
      DIED_RECEIVING_PROVINCIAL_INCOME_ASSISTANCE:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:DIED_RECEIVING_PROVINCIAL_INCOME_ASSISTANCE',
      DIED_RECEIVING_WORKERS_COMPENSATION:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:DIED_RECEIVING_WORKERS_COMPENSATION',
      DIED_RECEIVING_FERS_RETIREMENT:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:DIED_RECEIVING_FERS_RETIREMENT',
      DIED_ENTITLED_TO_RECEIVE_FERS_RETIREMENT:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:DIED_ENTITLED_TO_RECEIVE_FERS_RETIREMENT',
      DIED_MEMBER_OF_NATIVE_BAND:
        'GuidanceStepCypressAttribute:employmentDetails:inputs:DIED_MEMBER_OF_NATIVE_BAND'
    }
  },
  willsNoticeSearch: {
    inputs: {
      HAS_EXISTING_SEARCH:
        'GuidanceStepCypressAttribute:willsNoticeSearch:inputs:HAS_EXISTING_SEARCH',
      EXISTING_SEARCH_RESULTS:
        'GuidanceStepCypressAttribute:willsNoticeSearch:inputs:EXISTING_SEARCH_RESULTS',
      NEW_SEARCH_REQUIRED:
        'GuidanceStepCypressAttribute:willsNoticeSearch:inputs:NEW_SEARCH_REQUIRED'
    },
    buttons: {
      GENERATE: 'GuidanceStepCypressAttribute:willsNoticeSearch:buttons:GENERATE'
    }
  },
  companyService: {
    buttons: {
      detailAction: (key) =>
        `GuidanceStepCypressAttribute:buttons:COMPANY_SERVICE_DETAILS_ACTION-${key}`,
      SEARCH_LIFE_INSURANCE: 'GuidanceStepCypressAttribute:buttons:SEARCH_LIFE_INSURANCE',
      CLAIM_LIFE_INSURANCE: 'GuidanceStepCypressAttribute:buttons:CLAIM_LIFE_INSURANCE',
      CHANGE_PROVIDER: 'GuidanceStepCypressAttribute:buttons:CHANGE_PROVIDER'
    },
    inputs: {
      SEARCH_SERVICE: 'GuidanceStepCypressAttribute:inputs:SEARCH_SERVICE'
    },
    views: {
      details: (key) => `GuidanceStepCypressAttribute:views:COMPANY_SERVICE_DETAILS-${key}`,
      SEARCH_LIFE_INSURANCE: 'GuidanceStepCypressAttribute:views:SEARCH_LIFE_INSURANCE',
      CLAIM_LIFE_INSURANCE: 'GuidanceStepCypressAttribute:views:CLAIM_LIFE_INSURANCE',
      COMPANY_SERVICE_DETAILS: 'GuidanceStepCypressAttribute:views:COMPANY_SERVICE_DETAILS',
      REQUIRED_INFORMATION: 'GuidanceStepCypressAttribute:views:REQUIRED_INFORMATION',
      COMPANY_SERVICE_BOX: 'GuidanceStepCypressAttribute:views:COMPANY_SERVICE_BOX'
    }
  },
  step858794Form: {
    buttons: {
      PREVIEW: 'GuidanceStepCypressAttribute:step858794Form:buttons:PREVIEW'
    }
  },
  review: {
    views: {
      EXPANDABLE_TEXT: 'GuidanceStepCypressAttribute:review:views:EXPANDABLE_TEXT'
    },
    buttons: {
      EXPANDABLE_TEXT_TOGGLE: 'GuidanceStepCypressAttribute:review:buttons:EXPANDABLE_TEXT_TOGGLE'
    }
  }
};
